export default {
	DataType: {
		Appetite: "Appetite",
		Biomass: "Biomass",
		Dose: "Dose",
		FeedAmount: "Feed Amount",
		FishWeight: "Fish Weight",
		HandFeedWeight: "Hand Feed Weight",
		Intensity: "Intensity",
		Loadcell: "Loadcell",
		ManualAmount: "Manual Amount",
		Mean: "Mean",
		PelletCount: "Pellet Count",
		PelletFishMinute: "Pellet Fish Minute",
		Planned: "Planned",
		Recommended: "Recommended",
		SFR: "SFR",
		SGR: "SGR",
		StandardAppetite: "Standard Appetite",
		Target: "Target",
		TodayAppetite: "Today Appetite",
		TotalFeedWeight: "Total Feed Weight",
		avgWeight: "Average Weight",
		blowerSpeed: "Blower Speed",
		compass: "Compass",
		conductivity: "Conductivity",
		fcr: "FCR",
		feedStoreAmount: "Feed Store Amount",
		humidity: "Humidity",
		latitude: "Latitude",
		longitude: "Longitude",
		pellet_count: "Pellet Count",
		pressure: "Pressure",
		pressurePipe: "Pressure Pipe",
		recommendedFeedWeight: "Recommended Feed Weight",
		runtime: "Runtime",
		sal_conductivity: "Salinity Conductivity",
		sal_density: "Salinity Density",
		sal_sound_speed: "Salinity Sound Speed",
		sal_temp: "Salinity Temperature",
		saturation: "Saturation",
		sc_abs_tilt: "Sea Current Absolute Tilt",
		sc_heading: "Sea Current Heading",
		sc_max_tilt: "Sea Current Max Tilt",
		sc_sp_standard: "Sea Current Speed Standard",
		sc_std_tilt: "Sea Current Standard Tilt",
		sc_strength: "Sea Current Strength",
		sc_tilt_x: "Sea Current Tilt X",
		sc_tilt_y: "Sea Current Tilt Y",
		sea_current_absolute_speed: "Sea Current Speed",
		sea_current_direction: "Sea Current Direction",
		sea_current_east: "Sea Current East",
		sea_current_north: "Sea Current North",
		sensor_depth: "Sensor Depth",
		sgr: "SGR",
		smartSpreaderCycleTime: "Smart Spreader Cycle Time",
		smartSpreaderCyclicMax: "Smart Spreader Cyclic Max",
		smartSpreaderCyclicMin: "Smart Spreader Cyclic Min",
		smartSpreaderManualSpeed: "Smart Spreader Manual Speed",
		targetRecommended: "Target Recommended",
		temperatureFeedingLine: "Temperature Feeding Line",
		water_oxygen_mg_l: "Oxygen (mg/L)",
		water_oxygen_percentage: "Oxygen (%)",
		water_oxygen_umol: "Oxygen (μmol)",
		water_salinity: "Salinity",
		water_temperature: "Temperature",
		wind_direction: "Wind Direction",
		wind_speed: "Wind Speed",
	},
	DataTypeDescription: {
		AppetiteDescription: "Fish appetite level as a percentage",
		BiomassDescription: "Total estimated biomass weight",
		DoseDescription: "Feed dose per feeding event",
		FeedAmountDescription: "Total amount of feed dispensed",
		FishWeightDescription: "Estimated individual fish weight",
		HandFeedWeightDescription: "Weight of feed dispensed by hand",
		IntensityDescription: "Feed intensity rate",
		LoadcellDescription: "Loadcell weight measurement",
		ManualAmountDescription: "Manually registered feed amount",
		MeanDescription: "Mean feed weight",
		PelletCountDescription: "Number of pellets dispensed",
		PelletFishMinuteDescription: "Pellets per fish per minute",
		PlannedDescription: "Planned feed amount",
		RecommendedDescription: "Recommended feed amount",
		SFRDescription: "Specific feeding rate",
		SGRDescription: "Specific growth rate",
		StandardAppetiteDescription: "Standardized appetite level",
		TargetDescription: "Target feed amount",
		TodayAppetiteDescription: "Appetite level for today",
		TotalFeedWeightDescription: "Total weight of feed dispensed",
		avgWeightDescription: "Average fish weight",
		blowerSpeedDescription: "Feed blower speed",
		compassDescription: "Compass heading",
		conductivityDescription: "Electrical conductivity of water",
		fcrDescription: "Feed conversion ratio",
		feedStoreAmountDescription: "Amount of feed in storage",
		humidityDescription: "Air humidity level",
		latitudeDescription: "GPS latitude coordinate",
		longitudeDescription: "GPS longitude coordinate",
		pellet_countDescription: "Pellet count from sensor",
		pressureDescription: "Atmospheric or water pressure",
		pressurePipeDescription: "Feed pipe pressure",
		recommendedFeedWeightDescription: "Recommended feed weight amount",
		runtimeDescription: "Equipment runtime duration",
		sal_conductivityDescription: "Salinity sensor conductivity",
		sal_densityDescription: "Water density from salinity sensor",
		sal_sound_speedDescription: "Sound speed from salinity sensor",
		sal_tempDescription: "Temperature from salinity sensor",
		saturationDescription: "Oxygen saturation level",
		sc_abs_tiltDescription: "Absolute tilt of sea current sensor",
		sc_headingDescription: "Heading of sea current sensor",
		sc_max_tiltDescription: "Maximum tilt of sea current sensor",
		sc_sp_standardDescription: "Standard speed from sea current sensor",
		sc_std_tiltDescription: "Standard deviation of tilt",
		sc_strengthDescription: "Sea current signal strength",
		sc_tilt_xDescription: "Sea current sensor tilt on X-axis",
		sc_tilt_yDescription: "Sea current sensor tilt on Y-axis",
		sea_current_absolute_speedDescription: "Absolute speed of sea current",
		sea_current_directionDescription: "Direction of sea current",
		sea_current_eastDescription: "Eastward component of sea current",
		sea_current_northDescription: "Northward component of sea current",
		sensor_depthDescription: "Depth of the sensor",
		sgrDescription: "Specific growth rate",
		smartSpreaderCycleTimeDescription: "Cycle time for smart spreader",
		smartSpreaderCyclicMaxDescription: "Maximum cyclic speed of smart spreader",
		smartSpreaderCyclicMinDescription: "Minimum cyclic speed of smart spreader",
		smartSpreaderManualSpeedDescription: "Manual speed setting of smart spreader",
		targetRecommendedDescription: "Target recommended feed amount",
		temperatureFeedingLineDescription: "Temperature in the feeding line",
		water_oxygen_mg_lDescription: "Dissolved oxygen in mg per liter",
		water_oxygen_percentageDescription: "Dissolved oxygen as percentage",
		water_oxygen_umolDescription: "Dissolved oxygen in micromoles",
		water_salinityDescription: "Water salinity level",
		water_temperatureDescription: "Water temperature",
		wind_directionDescription: "Wind direction",
		wind_speedDescription: "Wind speed",
	},
};
